import { defineStore } from "pinia";
import http from "@/http";
import {
  CERTIFICADO_TEMP,
  ITEM_CERTIFICADO_TEMP,
  INSPECAO_TEMP,
  ITEM_INSPECAO_TEMP,
  MEDICOES_TEMP,
  ITEM_MEDICOES_TEMP,
  UPDATE_MEDICOES,
  UPDATE_ITEM_MEDICOES,
  CHECKLIST_TEMP,
  ITEM_CHECKLIST_TEMP,
  UPDATE_CHECKLIST,
  UPDATE_ITEM_CHECKLIST,
  PLANO_TEMP,
  ITEM_PLANO_TEMP,
  UPDATE_PLANO,
  UPDATE_ITEM_PLANO,
} from "@/http/url";

export const useTemplateStore = defineStore("TemplateStore", {
  state: () => {
    return {
      certificados: [],
      certificadoItens: [],
      inspecoes: [],
      inspecaoItens: [],
      medicoes: [],
      medicoesItens: [],
      listaDeChecagem: [],
      listaDeChecagemItens: [],
      planoDeManutencao: [],
      planoManutencaoItens: [],
      loaded: false,
    };
  },

  persist: { storage: sessionStorage },

  actions: {
    //CERTIFICADOS ----------------------------------------------
    LISTAR_CERTIFICADOS() {
      return new Promise((resolve, reject) => {
        http
          .get(CERTIFICADO_TEMP)
          .then((response) => {
            this.certificados = response.data;
            this.loaded = true;
            resolve("Ok");
          })
          .catch((erro) => {
            reject(erro);
          });
      });
    },

    LISTAR_ITENS(id) {
      return new Promise((resolve, reject) => {
        http
          .get(`${ITEM_CERTIFICADO_TEMP + id}`)
          .then((response) => {
            this.certificadoItens = response.data;
            resolve("Ok");
          })
          .catch((erro) => {
            reject(erro);
          });
      });
    },
    //INSPEÇÕES ----------------------------------------------
    LISTAR_INSPECOES() {
      return new Promise((resolve, reject) => {
        http
          .get(INSPECAO_TEMP)
          .then((response) => {
            this.inspecoes = response.data;
            this.loaded = true;
            resolve("Ok");
          })
          .catch((erro) => {
            reject(erro);
          });
      });
    },

    LISTAR_ITENS_INSPECAO(id) {
      return new Promise((resolve, reject) => {
        http
          .get(`${ITEM_INSPECAO_TEMP + id}`)
          .then((response) => {
            this.inspecaoItens = response.data;
            resolve("Ok");
          })
          .catch((erro) => {
            reject(erro);
          });
      });
    },
    //MEDIÇÕES ----------------------------------------------
    LISTAR_MEDICOES() {
      return new Promise((resolve, reject) => {
        http
          .get(MEDICOES_TEMP)
          .then((response) => {
            this.medicoes = response.data;
            this.loaded = true;
            resolve("Ok");
          })
          .catch((erro) => {
            reject(erro);
          });
      });
    },

    LISTAR_ITENS_MEDICAO(id) {
      return new Promise((resolve, reject) => {
        http
          .get(`${ITEM_MEDICOES_TEMP + id}`)
          .then((response) => {
            this.medicoesItens = response.data;
            resolve("Ok");
          })
          .catch((erro) => {
            reject(erro);
          });
      });
    },

    ALTERAR_MEDICOES(medicoes) {
      return http.put(`${UPDATE_MEDICOES + medicoes.id}`, medicoes);
    },

    ALTERAR_MEDICOES_ITEM(item) {
      return http.put(`${UPDATE_ITEM_MEDICOES + item.id}`, item);
    },

    //CHECKLIST ----------------------------------------------
    LISTAR_CHECKLIST() {
      return new Promise((resolve, reject) => {
        http
          .get(CHECKLIST_TEMP)
          .then((response) => {
            this.listaDeChecagem = response.data;
            this.loaded = true;
            resolve("Ok");
          })
          .catch((erro) => {
            reject(erro);
          });
      });
    },

    LISTAR_ITENS_CHECKLIST(id) {
      return new Promise((resolve, reject) => {
        http
          .get(`${ITEM_CHECKLIST_TEMP + id}`)
          .then((response) => {
            this.listaDeChecagemItens = response.data;
            resolve("Ok");
          })
          .catch((erro) => {
            reject(erro);
          });
      });
    },

    ALTERAR_CHECKLIST(listaDeChecagem) {
      return http.put(`${UPDATE_CHECKLIST + listaDeChecagem.id}`, listaDeChecagem);
    },

    ALTERAR_CHECKLIST_ITEM(item) {
      return http.put(`${UPDATE_ITEM_CHECKLIST + item.id}`, item);
    },

    //PLANO DE MANUTENÇÃO ----------------------------------------------
    LISTAR_PLANO() {
      return new Promise((resolve, reject) => {
        http
          .get(PLANO_TEMP)
          .then((response) => {
            this.planoDeManutencao = response.data;
            this.loaded = true;
            resolve("Ok");
          })
          .catch((erro) => {
            reject(erro);
          });
      });
    },

    LISTAR_ITENS_PLANO(id) {
      return new Promise((resolve, reject) => {
        http
          .get(`${ITEM_PLANO_TEMP + id}`)
          .then((response) => {
            this.planoManutencaoItens = response.data;
            resolve("Ok");
          })
          .catch((erro) => {
            reject(erro);
          });
      });
    },

    ALTERAR_PLANO(planoDeManutencao) {
      return http.put(`${UPDATE_PLANO + planoDeManutencao.id}`, planoDeManutencao);
    },

    ALTERAR_PLANO_ITEM(item) {
      return http.put(`${UPDATE_ITEM_PLANO + item.id}`, item);
    },
  },

  //Os getters precisam do state para acesso externo aos componentes
  getters: {
    //CERTIFICADOS ----------------------------------------------
    getCertificados() {
      return this.certificados;
    },

    getCertificadoItens(state) {
      return state.certificadoItens;
    },

    getFilterCertificados: (state) => {
      return (filtro) => {
        let filtrada = state.certificados;
        filtrada = filtrada.filter((obj) => !filtro || obj.descricao.includes(filtro));
        return filtrada;
      };
    },

    //INSPEÇÕES ----------------------------------------------
    getInspecoes() {
      return this.inspecoes;
    },

    getInspecaoItens(state) {
      return state.inspecaoItens;
    },

    getFilterInspecoes: (state) => {
      return (filtro) => {
        let filtrada = state.inspecoes;
        filtrada = filtrada.filter((obj) => !filtro || obj.descricao.includes(filtro));
        return filtrada;
      };
    },
    //MEDIÇÕES ----------------------------------------------
    getMedicoes() {
      return this.medicoes;
    },

    getMedicaoItens(state) {
      return state.medicoesItens;
    },

    getFilterMedicoes: (state) => {
      return (filtro) => {
        let filtrada = state.medicoes;
        filtrada = filtrada.filter((obj) => !filtro || obj.descricao.includes(filtro));
        return filtrada;
      };
    },

    //CHECKLIST ----------------------------------------------
    getChecklist() {
      return this.listaDeChecagem;
    },

    getChecklistItens(state) {
      return state.listaDeChecagemItens;
    },

    getFilterChecklist: (state) => {
      return (filtro) => {
        let filtrada = state.listaDeChecagem;
        filtrada = filtrada.filter((obj) => !filtro || obj.descricao.includes(filtro));
        return filtrada;
      };
    },

    //PLANO DE MANUTENCAO ----------------------------------------------
    getPlanolist() {
      return this.planoDeManutencao;
    },

    getPlanoItens(state) {
      return state.planoManutencaoItens;
    },

    getFilterPlano: (state) => {
      return (filtro) => {
        let filtrada = state.planoDeManutencao;
        filtrada = filtrada.filter((obj) => !filtro || obj.descricao.includes(filtro));
        return filtrada;
      };
    },

    getTemplateLoad(state) {
      return state.loaded;
    },
  },
});
